<template>
  <Form
    ref="formRef"
    v-slot="{ values, errors }"
    :initial-values="initialValues"
    :validation-schema="schema.validation || {}"
    @submit="onSubmit"
  >
    <SchemaFormLayout
      v-for="item in fields || []"
      :key="item.name"
      :parent="{}"
      :item="item"
      :values="values"
      :schema="schema"
      @component-event="v => $emit('component-event', v)"
    />
    <!-- hecky: emits values change -->
    <Events
      :values="cloneValue(values)"
      :errors="cloneValue(errors)"
      @change="onChange(values)"
      @error="onError(errors)"
    />
    <slot name="submit" />
  </Form>
</template>
<script>
import { computed, ref, provide, toRefs, defineComponent } from 'vue';
import { Form, configure } from 'vee-validate';
import SchemaFormLayout from './SchemaFormLayout.vue';
import Events from './Events.vue';
import { cloneDeep } from 'lodash-es';

// Default values
configure({
  validateOnBlur: true, // controls if `blur` events should trigger validation with `handleChange` handler
  validateOnChange: true, // controls if `change` events should trigger validation with `handleChange` handler
  validateOnInput: true, // controls if `input` events should trigger validation with `handleChange` handler
  validateOnModelUpdate: true, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
});

export default defineComponent({
  name: 'SchemaFormInternal',
  components: { Form, SchemaFormLayout, Events },
  props: {
    schema: { type: Object, default: () => ({}) },
    value: { type: Object, default: () => ({}) },
    globalData: { type: Object, default: () => ({}) },
    onSubmit: { type: Function, default: () => {} },
  },
  emits: ['valueChange', 'error', 'component-event'],
  setup(props, { emit }) {
    const fields = computed(() => {
      return props.schema.fields
        ? props.schema.fields.map(i => {
            if (i.type === 'group') {
              i.expanded = i.expanded === undefined ? true : i.expanded;
            }
            return i;
          })
        : [];
    });
    const { globalData } = toRefs(props);

    provide('globalData', globalData);

    const onChange = values => {
      // console.log('SchemaForm values changed', values, JSON.parse(JSON.stringify(values)));
      emit('valueChange', { ...values });
    };
    const onError = errors => emit('error', errors);

    // 合并schema与传入的初始值
    const initialValues = { ...props.schema.values, ...props.value };

    const formRef = ref(null);

    const cloneValue = values => cloneDeep(values);

    return {
      initialValues,
      fields,
      onChange,
      formRef,
      cloneValue,
      onError,
    };
  },
});
</script>
<style lang="less" scoped></style>
